import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router';
import { withOidcSecure } from '@axa-fr/react-oidc';
import { useDispatch, useSelector } from 'react-redux'
import { appTheme } from '../../../../helpers/utils/Utils';
// import smiERR from '../../../../../../assets/smi-kudzu-images/smi_mobile_error.png'
import smiERR from '../../../../assets/smi-kudzu-images/smi_mobile_error.png'
const UpdateNotificationErrorModal = ({ isSubErrMsg,ModalClose, errormsg }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);
 
    const handleOk = () => { 
        ModalClose(false)
        // navigate('/Toolkit/SavingGoals/ManageSavingGoal/ManageSavingGoalDetails');
        // dispatch({ type: "RESET_ALLOCATE_FUND" })
 
    }

    return (
        <div className=' flex flex-col justify-center items-center w-full'>
         
                <p className='font-hanken-grotesk font-[400] sm:font-[500] 
                leading-[24px] lg:text-[16px] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[22px] md:leading-[28px]
                 text-secondary-3'>{errormsg}</p>

          

            <img src={smiERR} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10' />
            <div className=' flex flex-col gap-4 justify-center items-center w-full'>
                <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={handleOk} onKeyDown={(e) => { if (e.key === "Enter") handleOk() }}>{t("try_again")}</button>
                <button className='focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[] text-[#2965FB] cursor-pointer  px-2 py-4 border-[#4B70B9] w-full' onClick={()=>{navigate("/Settings")}}>{t("Cancel")}</button>
            </div>

        </div>
    )
}

export default withOidcSecure(UpdateNotificationErrorModal)